var React = require('react');

function ArrowRound (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"34","cy":"34","r":"34","transform":"rotate(-180 34 34)","fill":"#F4DB8D","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33.9184 19.9581L31.5001 22.3764L41.1732 32.0495L20.0996 32.0495L20.0996 35.5042L41.1732 35.5042L31.5001 45.1774L33.9184 47.5956L47.7371 33.7769L33.9184 19.9581Z","fill":"#2D0469","key":1})]);
}

ArrowRound.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = ArrowRound;

ArrowRound.default = ArrowRound;
